import api from '@/logic/api'

export default {
  getTests: () => api.get('/tests-results'),
  getTestDetails: (testId) => api.get(`/tests/${testId}/details`),
  getSubmission: (submissionId) => api.get(`/tests/resultsWithAnswers/${submissionId}`),
  saveAnswer: (testId, testQuestionId, answers) => api.post(`/tests/${testId}/answer`, { test_question_id: testQuestionId, answers }),
  getCurrentQuestion: (testId) => api.get(`/tests/${testId}/currentquestion`),
}
